import React, { memo, useCallback, useMemo, useState } from "react";
import { Avatar, Button } from "antd";
import ContactDrawer from "./ContactDrawer";
import { StyledContactMessage } from "./style";
import { colorForContact, getInitials } from "./helper";

const ContactAvatar = ({ contact, size = 40 }) => {
  if (contact.avatarUrl) {
    return <Avatar size={size} src={contact.avatarUrl} />;
  }

  return (
    <Avatar
      size={size}
      style={{
        backgroundColor: colorForContact(contact),
        color: "#3a3a3a",
        fontWeight: 700,
      }}
    >
      {getInitials(contact.name)}
    </Avatar>
  );
};

const ContactMessage = ({ contacts = [], maxAvatars = 3 }) => {
  const [open, setOpen] = useState(false);

  const headline = useMemo(() => {
    if (!contacts.length) return "No contacts";

    const firstName = contacts[0]?.name || "Unknown";
    const remaining = contacts.length - 1;

    if (remaining <= 0) return firstName;

    return `${firstName} and ${remaining} other${
      remaining > 1 ? "s" : ""
    } contact${remaining > 1 ? "s" : ""}`;
  }, [contacts]);

  const showDrawer = useCallback(() => setOpen(true), []);
  const closeDrawer = useCallback(() => setOpen(false), []);

  return (
    <StyledContactMessage className="contact-chip-card">
      <div className="top-row">
        <div className="avatar-stack">
          {contacts.slice(0, maxAvatars).map((contact, index) => (
            <ContactAvatar
              key={contact.id ?? `${contact.name}-${index}`}
              contact={contact}
            />
          ))}
        </div>

        <div className="text-col">
          <div className="headline">{headline}</div>
        </div>
      </div>

      <hr className="divider" />

      <Button
        type="text"
        className="view-all-btn"
        size="small"
        onClick={showDrawer}
      >
        View all
      </Button>

      {open && <ContactDrawer contacts={contacts} onClose={closeDrawer} />}
    </StyledContactMessage>
  );
};

export default memo(ContactMessage);
